<template lang="html">
    <div
        class="nextLesson"
        v-if="lesson"
        :class="{ currentLesson: current_lesson, playerPage: $route.name == 'proPlayer' }"
    >
        <span
            class="pay"
            v-if="!lesson.guest_name"
            :class="{ credits: lesson.payment_type == 'credits' }"
        >
            {{ lesson.payment_type == "on_day" ? "Pay on day" : "Paid" }}
        </span>

        <div class="player" v-if="pro">
            <span v-if="lesson.guest_name">{{ lesson.guest_name }}</span>
            <span v-else>
                {{ lesson.player.first_name }} {{ lesson.player.last_name }}
                <a href="#" @click.prevent="clearActivePlayer" class="player_link"
                    ><img src="~@/assets/icons/profile.svg"
                /></a>
            </span>
        </div>

        <div class="date">
            {{ $date(lesson.date).format("D MMM") }} {{ lesson.start.substr(0, 5) }} -
            {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
            <router-link
                @click.native.prevent=""
                :to="{
                    name: 'proLessonDiarySetting',
                    params: {
                        start: $date(lesson.date).format('YYYY-MM-DD'),
                        end: $date(lesson.date).format('YYYY-MM-DD'),
                    },
                }"
                class="date_link"
                ><img src="~@/assets/icons/calendar.svg"
            /></router-link>
        </div>

        <div v-if="lesson.note" style="margin-top: 20px">
            <p>Notes:</p>

            <div class="notes">
                {{ lesson.note }}
            </div>
        </div>

        <div v-if="!current_lesson">
            <button
                @click.prevent="changeLesson"
                class="button dark half"
                type="button"
                name="button"
            >
                Change
            </button>

            <button
                @click.prevent="cancelLesson"
                class="button red half"
                type="button"
                name="button"
            >
                Cancel lesson
            </button>
        </div>

        <router-link
            v-else
            class="button dark"
            :to="{ name: 'proPlayerLesson', params: { id: lesson.player.id, lesson: lesson.id } }"
        >
            Create new Lesson record
            <img class="arrow" style="top: 17px" src="@/assets/plus-white.svg" />
        </router-link>
    </div>

    <div v-else :class="{ playerPage: $route.name == 'proPlayer' }">
        <div class="info" style="padding-top: 14px; font-size: 16px">
            <span>{{
                !$store.state.proLessonsLoaded && !player ? "Loading lessons..." : "No bookings"
            }}</span>
        </div>

        <router-link
            v-if="pro && player"
            class="button center"
            :to="{ name: 'proLessonBook', query: { id: player.id } }"
            >Book lesson</router-link
        >
    </div>
</template>

<script>
export default {
    name: "next-lesson",
    props: {
        pro: {
            required: false,
        },
        player: {
            required: true,
        },
        lesson: {
            required: false,
            default: () => {},
        },
        current_lesson: {
            required: false,
            default: false,
        },
    },
    methods: {
        clearActivePlayer() {
            this.$store.dispatch("clearActivePlayer");
            this.$router.push({ name: "proPlayer", params: { id: this.lesson.player.id } });
        },
        changeLesson() {
            this.$router.push({ name: "proLessonChange", params: { id: this.lesson.id } });
        },
        cancelLesson() {
            this.$confirm(
                "Are you sure you want to cancel this lesson?",
                () => {
                    window.axios.delete("/lesson/" + this.lesson.id).then((response) => {
                        if (this.pro) {
                            this.$emit("bookingCancelled");
                            this.$store.dispatch("getProLessons");
                        }

                        this.$emit("lessonCancelled", response.data.player_next_lesson);
                        this.$notify({
                            text: "This lesson has been cancelled. A notification has been sent to the player.",
                        });
                    });
                },
                "Yes",
                "No",
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.playerPage {
    background: white;
    padding: 20px;
    border-radius: 12px;
}
.nextLesson {
    background: $grey;
    padding: 20px;
    border-radius: $radius;
    position: relative;

    margin-bottom: 30px;

    &.currentLesson {
        background: #bbf8e0;
    }
    .pay {
        position: absolute;
        top: -15px;
        right: 20px;
        background: $red_1;
        border: 0px;
        padding: 7px 13px;
        display: block;
        margin-bottom: 20px;
        border-radius: 8px;
        color: white;
        font-size: 14px;
        &.credits {
            background: #60c45c;
        }
    }

    .player,
    .date,
    .notes {
        background: white;
        padding: 13px 20px;
        border-radius: $radius;
        margin-bottom: 10px;
        line-height: 1.5;
        color: $green_0;
        position: relative;
    }
    .notes {
        font-weight: 200;
    }
    p {
        margin-bottom: 10px;
        color: $green_0;
    }

    .player_link {
        position: absolute;
        width: 24px;
        right: 20px;
        img {
            width: 100%;
        }
    }

    .date_link {
        position: absolute;
        width: 17px;
        right: 24px;
        img {
            width: 100%;
        }
    }

    &.inverse {
        background: white;
        .player,
        .date,
        .notes {
            background: $grey;
        }
    }
}
</style>
